'use client'

import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'

import { flare, pulsechain } from 'wagmi/chains'

import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import React from 'react'

export const config = getDefaultConfig({
  appName: 'gemspump',
  projectId: 'f907a14ed3292e79703229f6e5bb7de5',
  chains: [flare, pulsechain],
  ssr: true,
})

const queryClient = new QueryClient()

export default function Web3Provider(props: { children: React.ReactNode }) {
  const [mounted, setMounted] = React.useState(false)
  React.useEffect(() => setMounted(true), [])

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>{mounted && props.children}</RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}
